import { Logout, ChartArcs3, CreditCard, Users, WorldWww, World, Photo } from 'tabler-icons-react';

export const Items = [
    {
        title: "Загрузка фото",
        icon: <Photo size={24} className="menu-icon"  />,
        href: "/upload-photo",
    },

    {
        title: "Лендинги",
        icon: <World size={24} className="menu-icon"  />,
        href: "/landing",
    },

    {
        title: "Пользователи",
        icon: <Users size={24} className="menu-icon"  />,
        href: "/user",
    },
    
    {
        title: "Выход",
        icon: <Logout size={24} className="menu-icon" />,
        href: "/exit",
    },

]